function shouldExcludeDeepCopyValue(
    exclude: ReadonlySet<string> | undefined,
    options: {
        key?: string;
        type: string;
    },
): boolean {
    if (!exclude) {
        return false;
    }

    return exclude.has(options.type) || (options.key !== undefined && exclude.has(options.key));
}

// ----------------------------------------------------------------------------

export { shouldExcludeDeepCopyValue };
